<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" :class="{'qr-scanner': isEditMode}">
        <div v-if="isEditMode" class="camera-placeholder">
            <i class="fas fa-qrcode"/>
        </div>
        <div v-else>
            <template v-if="!error">
                <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera">
                    <div class="loading" v-if="loading">
                        <i class="fas fa-spinner fa-spin fa-2x"/>
                        <div class="mt-2" v-tr>Loading Camera...|Chargement de l'appareil photo...</div>
                    </div>
                    <div v-else class="camera-placeholder"/>
                </qrcode-stream>
                <div class="stream-caption">
                    <em v-tr>Point your camera at a QR code to scan it.|Dirigez votre appareil photo vers un code QR pour le scanner.</em>
                </div>
            </template>
            <div v-show="error">
                <!--            <div class="stream-error">-->
                <!--                <div>-->
                <!--                    <span class="fa-stack fa-2x" style="opacity: 0.5">-->
                <!--                        <i class="fal fa-camera-alt fa-stack-1x text-gray"></i>-->
                <!--                        <i class="fal fa-ban fa-stack-2x"></i>-->
                <!--                    </span>-->
                <!--                    <div class="my-2" v-tr>No camera found|Aucune caméra trouvée</div>-->
                <!--                    <small class="text-gray" v-tr>If you have a camera, make sure to authorize access|Si vous avez une caméra, vérifiez que vous avez autorisé l'accès</small>-->
                <!--                </div>-->
                <!--            </div>-->
                <div class="mt-4">
                    <p v-tr>Take a picture to scan from your device.|Prendre une image à scanner à partir de votre appareil.</p>
                    <qrcode-capture ref="qrCapture" style="display: none" @decode="onDecode" @detect="onDetect"/>
                    <b-btn :block="isMobileLayout" variant="primary" @click="$refs.qrCapture.$el.click()">
                        <span v-tr>Take a picture|Prendre une photo</span>
                    </b-btn>
                </div>
            </div>
        </div>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader';
import store from "@/store.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";

// cms-block-container #hot-reload-debug
export default {
    name: `cms-block-container`,
    components: {
        CmsBlockRenderer,
        CmsBlock,
        QrcodeCapture, QrcodeStream
    },
    extends: CmsBlock,
    data() {
        return {
            loading: true,
            error: null,
            camera: `auto`
        }
    },
    methods: {
        async onInit(promise) {
            try {
                await promise;
                this.loading = false;
            } catch (err) {
                this.error = err;
                this.$emit(`error`, err);
            }
        },
        async onDetect(promise) {
            let { content } = await promise;
            if (!content)
                this.$emit(`invalid`);
        },
        onDecode(value) {
            if (value.indexOf(`ey&`) >= 0) {
                this.camera = `off`;
                this.$emit(`input`, `off`);
                this.loading = true;
                this.$emit(`decode`, value, _ => this.loading = false);
                this.$refs.qrCapture.$el.value = null;

                const params = new URLSearchParams(value);
                let route = new URLSearchParams();

                const start = params.get(`start`) || params.get(`depart`);
                if (start) {
                    route.append(`start`, start);
                }

                const end = params.get(`end`) || params.get(`arrivee`);
                if (end) {
                    route.append(`end`, end);
                }
                if (params.get(`qr`)) {
                    route.append(`qr`, params.get(`qr`));
                }
                const mapPage = this.cmsWebsite.getMapPage();
                if (mapPage) {
                    this.$router.push(`/${tr(mapPage.permalink)}?${route.toString()}`);
                } else {
                    console.error(`Error, no map page detected`);
                    return null;
                }
            }

            // this.showSavedMessage(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-qr-scanner {
    width: 100%;
    background: black;
    color: #fff;

    ::v-deep .cms-container {
        background: none !important;
        align-items: center;
    }

    .camera-placeholder {
        background: rgba(white, 0.2);
        width: 200px;
        height: 200px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 60px;
        border-radius: 5px;
        //border: 1px solid #eee;

        outline: 2px solid rgba(black, 0.2);
        outline-offset: -30px;
    }

    .qrcode-stream-wrapper,
    ::v-deep .qrcode-stream-overlay {
        display: flex;
        align-items: center;
        justify-content: center;

        .camera-placeholder {
            border: 1px solid rgba(white, 0.2);
            background: transparent;
        }
    }

    .stream-caption {
        padding: 10px;
    }
}
</style>
